// extracted by css-extract-rspack-plugin
export default {"cls1":"Typeahead-cls1_sqe","cls2":"Typeahead-cls2_dM4 Typeahead-cls1_sqe"};